var map = {
	"./0100/16x9/05.jpg": "k1An",
	"./0100/21x9/05.jpg": "ck9f",
	"./0100/3x2/05.jpg": "q7Vy",
	"./0100/4x1/05.jpg": "urQm",
	"./0100/4x3/05.jpg": "ZRje",
	"./0480/4x3/05.jpg": "274w",
	"./0800/3x2/05.jpg": "NjUQ",
	"./1200/16x9/05.jpg": "KYSA",
	"./1440/21x9/05.jpg": "7vC7",
	"./1920/4x1/05.jpg": "dNYl"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "XPtp";